import { useAuth } from "@/hooks/use-auth";

export function useUserRoles() {
    const { userInfo } = useAuth();
    const roles = userInfo?.roles ?? [];

    const hasRole = (role: string) => roles.includes(role);
    const hasAnyRole = (...requiredRoles: string[]) =>
        requiredRoles.some((r) => roles.includes(r));
    const hasAllRoles = (...requiredRoles: string[]) =>
        requiredRoles.every((r) => roles.includes(r));

    return { roles, hasRole, hasAnyRole, hasAllRoles };
}
